import React from 'react';
import PropTypes from 'prop-types';

import { ModalHOC } from 'common';
import { EditIcon, BasketIcon } from 'common/icons';
import { PaginationTable, ActionsButton } from 'common/components';
import { stripRtlWordMarks } from 'common/utils';

import { staticStyles } from './style';

const TemplatesTable = ({
  data,
  onRowClick,
  getList,
  handleDelete,
  showModal,
  loading,
  location,
  history,
  profile,
  params,
}) => {
  const rowProps = () => ({
    onClick: () => {},
  });

  const editTemplateClick = (e, id) => {
    e.stopPropagation();
    history.push(`/backoffice/templates/edit/${id}`);
  };

  const deleteTemplateClick = (e, id) => {
    e.stopPropagation();
    showModal({
      caption: { id: 'confirmDeleteTemplate' },
      content: {
        id: 'confirmText',
      },
      actionButton: {
        textId: 'justYes',
        handler: () => handleDelete({ id, queryParams: params }),
        type: 'error',
      },
      cancelButton: {
        textId: 'justNo',
      },
    });
  };

  /* eslint-disable */
  // ar 模板存的就是原文（输入什么存什么），这里只需右对齐展示；
  // stripRtlWordMarks 用于隐藏历史数据里可能残留的方向标记。
  const renderCell = (value, language) =>
    language === 'ar' ? (
      <span className="TemplatesTable__rtl-cell" dir="rtl">
        {stripRtlWordMarks(value)}
      </span>
    ) : (
      <span>{value}</span>
    );

  const columns = [
    {
      accessor: 'title',
      Header: 'justTitle',
      Cell: ({
        row: {
          original: { title, language },
        },
      }) => renderCell(title, language),
      isPreviewCell: true,
    },
    {
      accessor: 'text',
      Header: 'justText',
      Cell: ({
        row: {
          original: { text, language },
        },
      }) => renderCell(text, language),
      isPreviewCell: true,
    },
    {
      accessor: 'language',
      Header: 'justLanguage',
      Cell: ({
        row: {
          original: { language },
        },
      }) => <span>{language}</span>,
    },
    {
      accessor: 'action',
      Header: () => null,
      Cell: ({
        row: {
          original: { id },
        },
      }) => (
        <>
          {profile.perms.templateMessagesEditPerm && (
            <ActionsButton
              tooltipId={`Edit__tooltip-${id}`}
              tooltipTextId="justEdit"
              edit
              onClickFunc={e => editTemplateClick(e, id)}>
              <EditIcon />
            </ActionsButton>
          )}
          {profile.perms.fullAccessTemplateMessagesPerm && (
            <ActionsButton
              tooltipId={`Delete__tooltip-${id}`}
              tooltipTextId="justDelete"
              deleteType
              onClickFunc={e => deleteTemplateClick(e, id)}>
              <BasketIcon />
            </ActionsButton>
          )}
        </>
      ),
    },
  ];
  /* eslint-enable */

  return (
    <div className="TemplatesTable">
      <PaginationTable
        data={data}
        columns={columns}
        getTrProps={rowProps}
        onRowClick={onRowClick}
        getList={getList}
        loading={loading}
        location={location}
        history={history}
        params={params}
        isNewTable
      />
      <style jsx>{staticStyles}</style>
    </div>
  );
};

TemplatesTable.propTypes = {
  data: PropTypes.object.isRequired,
  onRowClick: PropTypes.func.isRequired,
  getList: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
};

TemplatesTable.defaultProps = {
  loading: false,
};

export default ModalHOC(TemplatesTable);
